import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'
import colors from '@settings/styleSettings'

import { Item } from '@generators/pdfComponents/Item'
import { Line } from '@generators/pdfComponents/Line'
import { BloodPressureStatus } from '@generators/pdfComponents/BloodPressureStatus'

const styles = StyleSheet.create({
  characteristic: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  line: {
    marginBottom: 24,
  },
})
const type = 'bloodPressure'

export const BloodPressure = ({ syst, diast }) => (
  <>
    <View style={styles.characteristic}>
      <Item label="Sistólica" text={syst} width={50} />
      <Item label="Diastólica" text={diast} width={56} />
      <BloodPressureStatus syst={syst} diast={diast} type={type} />
    </View>
    <Line lineColor={colors.softGray} style={styles.line} />
  </>
)

BloodPressure.propTypes = {
  syst: PropTypes.number.isRequired,
  diast: PropTypes.number.isRequired,
}
